module.exports = __webpack_public_path__ + "img/en.014f56e6.svg";